import { TextField, Typography } from '@mui/material'
import React from 'react'
import { singleMappingType } from '../../features/eventConfig/EventType'

function MappingContent({ type, mapping, handleMappingDataChange }: {
    type:string,
    mapping:singleMappingType,
    handleMappingDataChange: (updatedMapping : singleMappingType) => void
}) {


    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const updatedMapping = {
            ...mapping,
            [e.target.name]: e.target.value,
        }
        handleMappingDataChange(updatedMapping)
    }


    const handleMappingParamsChange = (key: string, value: string) => {
        const updatedMapping = {
            ...mapping,
            params: {
                ...mapping.params,
                [key]: value,
            }
        }
        handleMappingDataChange(updatedMapping)
    }

    return (
        <div className='event-config-single-mapping-wrapper'>
            <Typography variant='subtitle1' className='mapping-type-heading'>{type}</Typography>
            <div className='event-config-mapping-content-wrapper'>
                <TextField size='small' value={mapping.name} label="Event's Name" onChange={handleNameChange} name='name' />
                <div className='event-config-mapping-content'>
                    <Typography variant='subtitle2'>Params</Typography>
                    <div className='mapping-params-wrapper'>
                        {
                            Object.keys(mapping.params).map((key) => {
                                return <div className='mapping-event-single-param-wrapper' key={key}>
                                    <Typography variant='subtitle1' className='single-event-param-key'>{key} : </Typography>
                                    <TextField size='small' className='single-event-param-value-input' value={mapping.params[key]} onChange={(e) => handleMappingParamsChange(key, e.target.value)} name="params" />
                                </div>
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MappingContent